import React, { useState } from 'react'
import { Modal, Button, FormInstance } from 'antd'
import { useTranslation } from 'react-i18next'
import { Formula } from '../types/Formula'
import FormulaHelp from './FormulaHelp'
import { transformFieldData } from '../../../utils/form'
import FormulaForm from './FormulaForm'

interface FormulaModalProps {
  initialValues?: Formula
  formulaError?: any
  loading?: boolean
  visible: boolean
  handleSubmit: (values: any) => Promise<any>
  handleCancel: () => void
}

const FormulaFormModal: React.FC<FormulaModalProps> = ({
  initialValues,
  loading,
  visible,
  formulaError,
  handleSubmit,
  handleCancel
}) => {
  const [formInstance, setFormInstance] = useState<FormInstance>()
  const { t } = useTranslation()

  const config = {
    fontWeight: (value: any) => {
      return value && value === 'bold'
    }
  }

  return (
    <Modal
      style={{ maxWidth: 800, top: 5 }}
      width="unset"
      open={visible}
      destroyOnHidden
      maskClosable={false}
      onCancel={() => {
        handleCancel()
      }}
      title={t('formulaPage:formulaEditor')}
      styles={{
        body: {
          maxHeight: 'calc(100vh - 150px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingBottom: 0
        }
      }}
      footer={[
        <div key="help" style={{ float: 'left' }}>
          <FormulaHelp />
        </div>,
        <Button
          key="back"
          onClick={() => {
            formInstance?.resetFields()
            handleCancel()
          }}
        >
          {t('global:cancel')}
        </Button>,
        <Button
          loading={loading}
          key="submit"
          type="primary"
          onClick={async () => {
            try {
              const values = await formInstance?.validateFields()
              await handleSubmit(values)

              formInstance?.resetFields()
            } catch (error) {
              console.log('Validate Failed:', error)
            }
          }}
        >
          {t('global:save')}
        </Button>
      ]}
    >
      <FormulaForm
        formulaError={formulaError}
        initialValues={transformFieldData(initialValues, config)}
        onFormInstanceReady={instance => {
          setFormInstance(instance)
        }}
      />
    </Modal>
  )
}

export default FormulaFormModal
